import { get, useFormContext } from "react-hook-form";
import { PayeeEngagementStatus } from "@wingspanhq/wingspan-api-sdk";
import { SelectPayeeEngagement } from ".";
import { queriesPayeeRows } from "@query";
import { useState } from "react";

type Props = {
  name: string;
  disabled?: boolean;
  preselectedEmail?: string;
};

export const FormFieldSelectPayeeEngagement: React.FC<Props> = ({
  name,
  disabled,
  preselectedEmail
}) => {
  const { setValue, errors, clearErrors, watch, register } = useFormContext();

  const namePayeeId = `${name}.payeeId`;
  const namePayerPayeeEngagementId = `${name}.payerPayeeEngagementId`;

  const payeeId = watch(namePayeeId);
  const payerPayeeEngagementId = watch(namePayerPayeeEngagementId);

  const [autoFocus, setAutoFocus] = useState(false);

  queriesPayeeRows.searchPayeeRows.usePaginatedQuery(
    {
      filter: {
        searchString: preselectedEmail ? { eq: preselectedEmail } : undefined
      }
    },
    {
      enabled: !!preselectedEmail,
      onSuccess: result => {
        if (!preselectedEmail) {
          return;
        }

        const payeeRows = result.pages.flatMap(page => page.data ?? []);

        const payee = payeeRows.find(payee => payee.email === preselectedEmail);

        const filteredEngagements = (payee?.engagements ?? []).filter(
          e =>
            e.status === PayeeEngagementStatus.ACTIVATED &&
            e.metadata?.duplicate !== "true"
        );

        if (payee && filteredEngagements.length === 1) {
          setAutoFocus(false);
          setValue(namePayeeId, payee.id);
          setValue(
            namePayerPayeeEngagementId,
            filteredEngagements[0].payeeEngagementId
          );
        } else {
          setAutoFocus(true);
        }
      }
    }
  );

  return (
    <>
      <input type="hidden" name={namePayeeId} ref={register()} />
      <input type="hidden" name={namePayerPayeeEngagementId} ref={register()} />

      <SelectPayeeEngagement
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        defaultSearchText={preselectedEmail}
        disabled={disabled}
        value={
          payeeId && payerPayeeEngagementId
            ? { payeeId, payerPayeeEngagementId }
            : null
        }
        onChange={newValue => {
          if (newValue) {
            clearErrors(name);
            setValue(namePayeeId, newValue.payeeId);
            setValue(
              namePayerPayeeEngagementId,
              newValue.payerPayeeEngagementId
            );
          } else {
            setValue(namePayeeId, null);
            setValue(namePayerPayeeEngagementId, null);
          }
        }}
        status={get(errors, namePayerPayeeEngagementId) ? "error" : undefined}
        message={get(errors, namePayerPayeeEngagementId)?.message}
      />
    </>
  );
};
